module.exports = __webpack_public_path__ + "static/media/live-births.12c01c26.jpg";